/* ============================================================
   Dathent — brand icons (filled platform marks) + tints
   Ported from design pack shared/icons.jsx → ES module.
   ============================================================ */
import React from 'react';

export const BrandIcons = {
  instagram: (p = {}) => (
    <svg width={p.size || 16} height={p.size || 16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="5"/>
      <circle cx="12" cy="12" r="4"/>
      <circle cx="17.5" cy="6.5" r="1.1" fill="currentColor" stroke="none"/>
    </svg>
  ),
  facebook: (p = {}) => (
    <svg width={p.size || 16} height={p.size || 16} viewBox="0 0 24 24" fill="currentColor">
      <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46H15.19c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33V21.88C18.343 21.128 22 16.99 22 12z"/>
    </svg>
  ),
  linkedin: (p = {}) => (
    <svg width={p.size || 16} height={p.size || 16} viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.5 2h-17A1.5 1.5 0 0 0 2 3.5v17A1.5 1.5 0 0 0 3.5 22h17a1.5 1.5 0 0 0 1.5-1.5v-17A1.5 1.5 0 0 0 20.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 1 1 8.25 6.5 1.75 1.75 0 0 1 6.5 8.25zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0 0 13 14.19a.66.66 0 0 0 0 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 0 1 2.7-1.4c1.55 0 3.36.86 3.36 3.66z"/>
    </svg>
  ),
  x: (p = {}) => (
    <svg width={p.size || 16} height={p.size || 16} viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
    </svg>
  ),
  tiktok: (p = {}) => (
    <svg width={p.size || 16} height={p.size || 16} viewBox="0 0 24 24" fill="currentColor">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.91A8.16 8.16 0 0 0 21.5 10.4V7a4.84 4.84 0 0 1-1.91-.31z"/>
    </svg>
  ),
  telegram: (p = {}) => (
    <svg width={p.size || 16} height={p.size || 16} viewBox="0 0 24 24" fill="currentColor">
      <path d="M21.05 3.32 2.36 10.53c-1.27.49-1.26 1.18-.23 1.49l4.78 1.49 11.05-6.98c.52-.32 1-.15.61.2l-8.95 8.07h-.01l.01.01-.33 4.93c.5 0 .72-.23 1-.5l2.4-2.34 4.99 3.68c.92.51 1.58.25 1.81-.85L21.95 4.95c.34-1.35-.51-1.97-1.4-1.63z"/>
    </svg>
  ),
  threads: (p = {}) => (
    <svg width={p.size || 16} height={p.size || 16} viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.65 11.16c-.1-.05-.21-.1-.31-.14-.18-3.4-2.04-5.35-5.15-5.37h-.04c-1.86 0-3.4.79-4.36 2.24L9.5 8.85c.71-1.07 1.83-1.3 2.65-1.3h.03c1.02.01 1.79.31 2.29.89.36.43.61 1.02.73 1.78a13 13 0 0 0-2.9-.14c-2.92.17-4.8 1.88-4.67 4.25.06 1.2.66 2.23 1.69 2.9.86.57 1.97.85 3.13.79 1.53-.08 2.73-.66 3.57-1.73.64-.81 1.04-1.86 1.22-3.18.74.45 1.28 1.04 1.59 1.75.52 1.21.55 3.2-1.07 4.82-1.42 1.42-3.13 2.03-5.71 2.05-2.86-.02-5.03-.94-6.43-2.74C4.32 17.45 3.64 15.06 3.62 12s.7-5.45 2-7.07c1.4-1.8 3.57-2.72 6.43-2.74 2.88.02 5.09.94 6.55 2.75.72.89 1.26 2 1.62 3.31l1.94-.52c-.44-1.61-1.13-3-2.05-4.14C18.27 1.32 15.7.17 12.23.15h-.02C8.74.17 6.21 1.32 4.6 3.6 3.16 5.62 2.42 8.45 2.39 11.99v.02c.03 3.54.77 6.37 2.21 8.39 1.61 2.28 4.14 3.44 7.61 3.46h.02c3.09-.02 5.27-.83 7.06-2.61 2.34-2.34 2.27-5.27 1.5-7.07-.55-1.29-1.61-2.34-3.07-3.04zm-5.36 5.42c-1.28.07-2.62-.51-2.68-1.74-.05-.91.65-1.93 2.76-2.05.24-.01.48-.02.71-.02.77 0 1.49.07 2.13.22-.24 2.97-1.63 3.52-2.92 3.59z"/>
    </svg>
  ),
  youtube: (p = {}) => (
    <svg width={p.size || 16} height={p.size || 16} viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.6 3.5 12 3.5 12 3.5s-7.6 0-9.4.6A3 3 0 0 0 .5 6.2 31 31 0 0 0 0 12a31 31 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.8.6 9.4.6 9.4.6s7.6 0 9.4-.6a3 3 0 0 0 2.1-2.1A31 31 0 0 0 24 12a31 31 0 0 0-.5-5.8zM9.6 15.6V8.4l6.3 3.6z"/>
    </svg>
  ),
};

export const BrandTints = {
  instagram: { from: '#F58529', to: '#DD2A7B', text: '#fff' },
  facebook: { from: '#1877F2', to: '#0E5BC1', text: '#fff' },
  linkedin: { from: '#0A66C2', to: '#0848A0', text: '#fff' },
  x: { from: '#000000', to: '#1A1A1A', text: '#fff' },
  tiktok: { from: '#111111', to: '#000000', text: '#fff' },
  telegram: { from: '#2AABEE', to: '#229ED9', text: '#fff' },
  threads: { from: '#1A1A1A', to: '#000000', text: '#fff' },
  youtube: { from: '#FF0000', to: '#CC0000', text: '#fff' },
};

export default BrandIcons;
